import type { SVGProps } from "react";
export interface SignalBroadcast03IconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function SignalBroadcast03Icon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: SignalBroadcast03IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M13.508 12a1.508 1.508 0 0 0-2.832-.72 1.125 1.125 0 0 1-1.975-1.078 3.756 3.756 0 1 1 5.097 5.097 1.126 1.126 0 0 1-1.079-1.974c.472-.257.788-.755.789-1.324Zm1.363-7.025.115.02.372.093a5.26 5.26 0 0 1 3.558 3.558l.095.372.018.114a1.124 1.124 0 0 1-2.188.473l-.03-.11-.054-.213a3.01 3.01 0 0 0-2.035-2.035l-.213-.054-.11-.03a1.124 1.124 0 0 1 .472-2.188m.93-4.093.113.018.336.079a9.4 9.4 0 0 1 6.854 7.11 1.125 1.125 0 1 1-2.199.475 7.15 7.15 0 0 0-4.961-5.335L15.44 3.1l-.112-.03a1.125 1.125 0 0 1 .474-2.188Z"
      />
      <path
        fill={color}
        d="M4.306 4.999c.261-.078.546-.09.813-.036l.133.033.186.069c.173.076.306.174.404.256.116.097.235.217.324.306l12.207 12.207c.089.088.21.207.306.323.082.099.18.233.256.406l.07.186.031.132c.055.267.043.552-.035.813l-.044.129c-.133.338-.385.583-.552.725l-.13.108c-4.165 3.491-10.38 3.28-14.296-.635S-.148 9.89 3.343 5.725l.109-.13c.142-.167.387-.417.725-.551zm.521 2.47a8.35 8.35 0 0 0 11.7 11.701l-11.7-11.7Z"
      />
    </svg>
  );
}
